module.exports = __webpack_public_path__ + "img/feature_buy_th.bd21191b.png";